import BudgetRoute from "./Budget/Routes";
import AccountRoute from "./Account/Routes";
// import InventoryRoute from "./Inventory/Routes";
import NoteSheetRoute from "./NoteSheet/Routes";
import PreSanctionRoute from "./PreSanction/Routes";
import FinalBill from "./FinalBill/Routes";
import MasterStore from "./MasterStore/Routes";

import AuditRoute from "./Voucher/Audit/Routes";
// import SalesRoute from "./Voucher/Sales/Routes";
// import RecipeRoute from "./Voucher/Recipe/Routes";
import PaymentRoute from "./Voucher/Payment/Routes";
import JournalRoute from "./Voucher/Journal/Routes";
import PurchaseRoute from "./Voucher/Purchase/Routes";
import ReceivedRoute from "./Voucher/Received/Routes";

import ReportRoute from "./Reports";
import Settings from "./Settings";

export default [
    ...AuditRoute,
    ...AccountRoute,
    // ...InventoryRoute,
    ...NoteSheetRoute,
    ...FinalBill,
    ...MasterStore,
    ...PreSanctionRoute,
    ...PurchaseRoute,
    ...PaymentRoute,
    ...ReceivedRoute,
    ...JournalRoute,
    ...BudgetRoute,
    ...ReportRoute,
    ...Settings,
];
